import Environment from '@env/environment.model';

export default new Environment(
    {baseUrl: 'https://api.esk.immo'},
    {dsn: 'https://90e3112bf003426386dfa8a107f7062c@sentry.io/1201143', enabled: true, environment: 'prod'}
);
